import React from "react";
import classes from "./PlanUpsell.module.scss";

const planUpsell = (props) => (
  <>
    {props.planUpsellValuesSelected && props.planRecommendationSelected && (
      <div className={classes.PlanUpsell}>
        <div className={classes.title}>You may also consider:</div>
        <div className={classes.planTitle}>
          {props.planUpsellValuesSelected.plan}
        </div>
        <div className={classes.priceRange}>
          Starts At {props.planUpsellValuesSelected.priceRange}
        </div>
        <div className={classes.savings}>
          <strong>{props.planUpsellValuesSelected.avgSavings}</strong> Average
          Savings Off Single-Game Price
        </div>
        <div className={classes.benefit}>
          You will receive all the benefits included with the{" "}
          {props.planRecommendationSelected.plan} <strong>PLUS</strong>:
          {props.planRecommendationSelected.slug === "eightyBallpark" ? (
            <ul>
              <li>Postseason Guarantee</li>
              <li>VIP Ballpark Entrance</li>
              <li>VIP Concessions Lines</li>
            </ul>
          ) : (
            <ul>
              {props.planUpsellValuesSelected.benefits.map((res, index) => (
                <li key={index}>{res}</li>
              ))}
            </ul>
          )}
        </div>
        <div
          className={classes.blueButton}
          onClick={() => {
            if (window.adobeAnalytics && window.adobeAnalytics.tl) {
              window.adobeAnalytics.tl(
                true,
                "o",
                `Washington Nationals: Tickets: Nationals Ticketfinder: We Recommend: you may also consider: ${props.planUpsellValuesSelected["slug"]} plan : upgrade to ${props.planUpsellValuesSelected["slug"]} plan button click`,
                {
                  prop12: "Nationals TicketFinder",
                  prop13:
                    "Washington Nationals: Tickets: Nationals Ticketfinder: We Recommend",
                  prop14: `you may also consider: ${props.planUpsellValuesSelected["slug"]} plan : upgrade to ${props.planUpsellValuesSelected["slug"]} plan button click`,
                }
              );
            }

            props.onClickChooseMyPlansToggle(
              props.planUpsellValuesSelected["slug"]
            );
          }}
        >
          Upgrade to <span>{props.planUpsellValuesSelected.plan}</span>
        </div>
      </div>
    )}
  </>
);

export default planUpsell;
